(() => {
  const source = document.getElementById('LeiaUiLanguage');
  if (!source) return;
  let labels;
  try { labels = JSON.parse(source.textContent); } catch (_) { return; }
  const setText = (element, text) => {
    if (element && element.textContent !== text) element.textContent = text;
  };
  const localizeWidgets = () => {
    document.querySelectorAll('variant-selects fieldset').forEach(field => {
      const selected = field.querySelector('input[type="radio"]:checked');
      const label = selected?.getAttribute('data-leia-option-label');
      if (label) setText(field.querySelector('legend [data-selected-value]'), label);
    });
    document.querySelectorAll('.scr-open-size-chart').forEach(button => setText(button, labels.sizeGuide));
    document.querySelectorAll('.scr-modal').forEach(modal => {
      modal.setAttribute('aria-label', labels.sizeGuide);
      const close = modal.querySelector('.scr-close');
      if (close) close.setAttribute('aria-label', labels.close);
      setText(modal.querySelector('.scr > h2'), labels.sizeGuide);
      const headers = [labels.size, labels.bust, labels.waist, labels.hips];
      modal.querySelectorAll('.scr-table tr:first-child th').forEach((cell, index) => {
        if (headers[index]) setText(cell, headers[index]);
      });
      setText(modal.querySelector('.bottom-description p'), labels.centimeters);
    });
    document.querySelectorAll('[id*="gsc_instagram_feed"]').forEach(widget => {
      setText(widget.querySelector('h3'), labels.instagram);
      const walker = document.createTreeWalker(widget, NodeFilter.SHOW_TEXT);
      const changes = [];
      while (walker.nextNode()) {
        const text = walker.currentNode;
        if (text.textContent.trim() === 'Join our community for daily inspiration and a closer look at our creations') changes.push(text);
        if (text.textContent.trim() === 'Run on GSC') setText(text, labels.instagramCredit);
      }
      changes.forEach(text => {
        text.textContent = labels.instagramIntro;
        text.parentElement.classList.add('leia-app-intro');
      });
    });
  };
  const observer = new MutationObserver(localizeWidgets);
  observer.observe(document.body, { childList: true, subtree: true });
  localizeWidgets();
  document.addEventListener('change', event => {
    if (event.target.closest('variant-selects')) requestAnimationFrame(localizeWidgets);
  });
  window.addEventListener('pagehide', () => observer.disconnect(), { once: true });
})();
